import clsx from "clsx";
import type { Delta } from "../lib/types";
import { signedPct } from "../lib/format";
import { IconArrowUp, IconArrowDown } from "./icons";

type GoodDirection = "up" | "down" | "neutral";

/**
 * A week-over-week delta. Colour encodes GOOD vs BAD (not merely up/down):
 * for conversions up is good; for cost-per-conversion up is bad. An arrow shows
 * the raw direction so meaning is never carried by colour alone.
 */
export function DeltaBadge({
  delta,
  good = "up",
  className,
}: {
  delta: Delta | undefined;
  good?: GoodDirection;
  className?: string;
}) {
  if (!delta) return <span className="text-muted">—</span>;

  const dir =
    delta.pct == null
      ? delta.absolute > 0
        ? "up"
        : delta.absolute < 0
          ? "down"
          : "flat"
      : delta.pct > 0
        ? "up"
        : delta.pct < 0
          ? "down"
          : "flat";

  const isGood = good === "neutral" || dir === "flat" ? null : dir === good;
  const color =
    isGood === null ? "text-muted" : isGood ? "text-good" : "text-critical";

  const label = delta.pct == null ? (dir === "flat" ? "—" : "new") : signedPct(delta.pct);

  return (
    <span className={clsx("inline-flex items-center gap-0.5 text-xs tnum", color, className)}>
      {dir === "up" && <IconArrowUp width={12} height={12} />}
      {dir === "down" && <IconArrowDown width={12} height={12} />}
      {label}
    </span>
  );
}
